import {api} from "./service.js";	
const user={
	login(info){//获取新闻列表
		return api.post("pc/user/login",info)
	},
	register(info){
		return api.post("pc/user/add",info)
	},

	newRegister(info){
		return api.post("pc/user/add",info)
	},

	savehelp(info){
		return api.post("pc/contact/add",info)
	},
	sendMail(){
		var id = localStorage.getItem("currentUser_id");
		return api.post("pc/mail/resend",{id:id})
	},
	getUserInfo(){		
		return api.post("pc/user/info")
	},
	//修改个人信息
	saveUser(info){
		return api.post("pc/user/update",info)
	},
	//更改密码
	resetPasswords(info){
		return api.post("pc/password/update",info)
	},
	//注销账号
	deleteUser(info){
		return api.post("pc/user/del",info)
	},
	//激活账户
	activityUser(code){
		return api.post("pc/user/act",{code:code})
	},
	//发送邮件
	sendMailByno(mailurl){
		return api.post("pc/password/mail",{mail:mailurl})
	},
	resetPassword(info){
		return api.post("pc/password/reset",info)
	},
	
	//发送验证码
	sendCode(info){
		return api.post("pc/sign/code",info)
	},
	//发送邮箱验证码
	sendMailCode(info){
		return api.post("pc/mail/code",info)
	},
	//绑定手机号或者邮箱
	binDing(info){
		return api.post("pc/user/bind",info)
	},
	//修改密码
	passwordUpdate(info){
		return api.post("pc/password/update",info)
	},
	//忘记密码发送邮件接口
	passwordMail(info){
		return api.post("pc/password/mail",info)
	},
	//判断用户是否存在
	userExist(info){
		return api.post("pc/user/exist",info)
	}
	
}
export default user;


// WEBPACK FOOTER //
// ./src/service/user.js